/* Pezold: "Direkt zur Kasse" – legt das Stück in den Warenkorb und öffnet den echten Shopify-Checkout. */
(() => {
  if (window.__pzDirectCheckoutAttached) return;
  window.__pzDirectCheckoutAttached = true;
  const S = window.pzStrings || {};
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-pz-direct-checkout]');
    if (!button || button.disabled) return;
    const form = document.getElementById(button.dataset.pzProductFormId);
    if (!form) return;
    const errorArea = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const errorText = errorArea?.querySelector('.product-form__error-message');
    const originalLabel = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = S.going || 'Weiter zur Kasse …';
    if (errorArea) errorArea.hidden = true;
    try {
      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) throw new Error(S.addErr || 'Der Artikel konnte nicht hinzugefügt werden.');
      const data = new FormData(form);
      if (!data.get('id')) data.set('id', variantId);
      const path = window.routes?.cart_add_url || '/cart/add';
      const response = await fetch(path + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || S.addErr || 'Der Artikel konnte nicht hinzugefügt werden.');
      }
      const root = window.Shopify?.routes?.root || '/';
      window.location.assign(root.replace(/\/?$/, '/') + 'checkout');
    } catch (error) {
      const message = error?.message || S.addErr || 'Bitte versuchen Sie es erneut.';
      if (errorText) errorText.textContent = message;
      if (errorArea) { errorArea.hidden = false; errorArea.scrollIntoView({ block: 'nearest' }); }
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.innerHTML = originalLabel;
    }
  });
})();
